import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './SideBar';
import Topbar from './Topbar';
import $ from 'jquery';
import NavIcons from './NavIcons';
import './../Css/navStyles.scss';
import usePushNotifications from '../hooks/usePushNotifications';
import { CommentDockProvider } from '../context/CommentDockContext';
import { NotificationsProvider } from '../context/NotificationsContext';
import CommentDockHost from './comments/CommentDockHost';
import { UserAccessProvider } from '../context/UserAccessContext';

function Dashboard() {
    usePushNotifications();
    const location = useLocation();
    const navigate = useNavigate(); // Added useNavigate hook
    const [activeMenu, setActiveMenu] = useState(location.pathname);
    const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [isSNavOpen, setNavOpen] = useState(true);
    const [fixedOpen, setFixedOpen] = useState(false);
    let isFixed = localStorage.getItem('fixedSideBar');
    if (isFixed === undefined) {
        localStorage.setItem('fixedSideBar', false);
        isFixed = false;
    }

    const handleMenuClick = (menu, path) => {
        setActiveMenu(menu); 
        setSidebarCollapsed(true);
        setNavOpen(false);
        localStorage.setItem('fixedSideBar', true);
        isFixed = true;
        navigate(path); // Programmatically navigate to the selected route
    };

    const toggleSidebar = () => {
        setSidebarCollapsed(!isSidebarCollapsed);
        if (isSNavOpen) {
            setNavOpen(false);
            setSidebarCollapsed(true);
        } else {
            setNavOpen(true);
            setSidebarCollapsed(false);
        }
        localStorage.setItem('fixedSideBar', false);
        isFixed = false;
    };

    const navToggle = (path) => {
        debugger
        setNavOpen(!isSNavOpen);
        if (isSidebarCollapsed) {
            setSidebarCollapsed(false);
            setNavOpen(true);
        } else {
            setNavOpen(false);
            setFixedOpen(true);
            setSidebarCollapsed(true);
        }
        handleMenuClick(path)
    };

    return (
        // Who may open what (User Administration); the sidebar shows Administration to IT Managers only.
        <UserAccessProvider>
        <CommentDockProvider>
        {/* Bell, tray chats and the Orders comment icons all read unread counts from here. */}
        <NotificationsProvider>
        <div className="container-fluid p-0">
            <div className="row flex-nowrap">
                {/* Sidebar */}
                <div className={`col-auto px-0 gf-sidebar-wrap vh-100 side-wrap ${isSidebarCollapsed ? 'active-side-wrap' : 'deactive-side-wrap'}`}>
                    <Sidebar activeMenu={activeMenu} setActiveMenu={setActiveMenu} isSidebarCollapsed={isSidebarCollapsed} toggleSidebar={toggleSidebar} handleMenuClick={handleMenuClick} />
                </div>

                {/* Nav Icons */}
                <div className={`col-auto px-0 bg-light vh-100 side-wrap ${isSNavOpen ? 'active-side-wrap' : ''}`}>
                    <NavIcons navToggle={navToggle} />
                </div>

                {/* Main Content */}
                <div className={`col bg-light ps-3 w-75`}>
                    <Topbar />
                    <div className="p-4 pt-0">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
        <CommentDockHost />
        </NotificationsProvider>
        </CommentDockProvider>
        </UserAccessProvider>
    );
}

export default Dashboard;
